import { createTheme } from '../utils';
import * as TravellerForm from './components/TravellerForm/TravellerForm.css';
import * as Preferences from './components/Preferences/Preferences.css';
import * as SectionWrapper from './components/SectionWrapper/SectionWrapper.css';
import * as DocumentsSection from './components/DocumentsSection/DocumentsSection.css';
import * as DocumentFieldsItem from './components/DocumentsSection/DocumentFieldsItem/DocumentFieldsItem.css';
import * as PersonalInfoSection from './components/PersonalInfoSection/PersonalInfoSection.css';
import * as ContactsSection from './components/ContactsSection/ContactsSection.css';
import * as DesktopDirections from './components/DirectionsSection/components/DesktopDirections/DesktopDirections.css';
import * as MobileDirections from './components/DirectionsSection/components/MobileDirections/MobileDirections.css';
import * as DocumentCard from './components/DocumentsSection/DocumentCard/DocumentCard.css';
import * as AddDocumentModal from './components/DocumentsSection/AddDocumentModal/AddDocumentModal.css';
import * as DocumentFormFields from './components/DocumentsSection/DocumentFormFields/DocumentFormFields.css';
export const defaultTheme = {
    TravellerForm,
    Preferences,
    SectionWrapper,
    DocumentsSection,
    DocumentFieldsItem,
    PersonalInfoSection,
    ContactsSection,
    DesktopDirections,
    MobileDirections,
    DocumentCard,
    AddDocumentModal,
    DocumentFormFields
};
export default defaultTheme;
export const { useTheme } = createTheme(defaultTheme);
